'use strict';

angular.module('userRequestEditControllers')

.controller('MissingSystemAccountController', ['$scope', 'editAccessRequestService', function ($scope, editAccessRequestService) {

    $scope.ctxtMissingSysAcc = {};
    $scope.ctxtMissingSysAcc.displayMissingAccount = true;

    $scope.addMissingSystemAccount = function () {
        editAccessRequestService.request.addSystemAccount($scope.userRequest.UserAccessRequestID,
                                                          $scope.ctxtMissingSysAcc.missingSystemId,
                                                          $scope.ctxtMissingSysAcc.missingSystemAccount)
        .then(function (response) {
            if (response.statusText === 'OK' && _.isUndefined(response.data.GrowlMessages)) {
                $scope.ctxtMissingSysAcc.displayMissingAccount = false;
            }
        });
    }
}]);